import React, { useState } from "react";
import { useParams } from "react-router-dom";

// Import all wagon components
import A2 from "../helpers/wagons/A2";
import AB3 from "../helpers/wagons/AB3";
import ABS5 from "../helpers/wagons/ABS5";
import B1 from "../helpers/wagons/B1";
import B1S from "../helpers/wagons/B1S";
import B5 from "../helpers/wagons/B5";
import B7 from "../helpers/wagons/B7";
import Y1 from "../helpers/wagons/Y1";
import Co2 from "../helpers/wagons/Co2";
import Co12 from "../helpers/wagons/Co12";
import Co65 from "../helpers/wagons/Co65";
import C49 from "../helpers/wagons/C49";
import Y6 from "../helpers/wagons/Y6";
import Y7 from "../helpers/wagons/Y7";
import Y8 from "../helpers/wagons/Y8";
import B22 from "../helpers/wagons/B22";
import B22D from "../helpers/wagons/B22D";
import Co4a from "../helpers/wagons/Co4a";
import CD268 from "../helpers/wagons/CD268";

const wagonComponents = {
    A2,
    AB3,
    ABS5,
    B1,
    B1S,
    B5,
    B7,
    B22,
    B22D,
    Y1,
    Co2,
    Co4a,
    Co12,
    Co65,
    C49,
    Y6,
    Y7,
    Y8,
    CD268,
};

const WagonDev = () => {
    const { wagonType } = useParams();

    // Normalize wagon type: convert to uppercase and find matching component
    const normalizeWagonType = (type) => {
        if (!type) return 'Y6';

        const upperType = type.toUpperCase();

        // Check if exact match exists
        if (wagonComponents[upperType]) {
            return upperType;
        }

        // Try to find case-insensitive match
        const matchingKey = Object.keys(wagonComponents).find(
            key => key.toUpperCase() === upperType
        );

        return matchingKey || 'Y6';
    };

    const [selectedWagon, setSelectedWagon] = useState(normalizeWagonType(wagonType));

    const WagonComponent = wagonComponents[selectedWagon];

    // Mock props for development
    const mockProps = {
        id: 1,
        reservedSeats: [],
        preliminaryReservedSeats: [],
        announcedNumber: "1",
        number: 1,
    };

    return (
        <div className="min-h-screen bg-gray-100 py-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="bg-white rounded-lg shadow p-6 mb-6">
                    <h1 className="text-2xl font-bold text-gray-900 mb-4">
                        Wagon Development Preview
                    </h1>

                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Select Wagon Type:
                        </label>
                        <select
                            value={selectedWagon}
                            onChange={(e) => setSelectedWagon(e.target.value)}
                            className="block w-64 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                        >
                            {Object.keys(wagonComponents).map((type) => (
                                <option key={type} value={type}>
                                    {type}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="text-sm text-gray-600 mb-4">
                        <p><strong>Current Wagon:</strong> {selectedWagon}</p>
                        <p><strong>Props:</strong> All seats available, no reservations</p>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow p-6">
                    <div className="flex justify-center">
                        {WagonComponent ? (
                            <WagonComponent {...mockProps} />
                        ) : (
                            <p className="text-red-600">
                                Wagon component "{selectedWagon}" not found
                            </p>
                        )}
                    </div>
                </div>

                <div className="mt-6 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                    <p className="text-sm text-yellow-800">
                        <strong>Development Mode:</strong> This route is for development purposes only.
                        Access it at: /dev/wagon or /dev/wagon/Y6
                    </p>
                </div>
            </div>
        </div>
    );
};

export default WagonDev;
